var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.02 11.293a1 1 0 0 0-1.413 0l-7.071 7.07-2.829-2.828a1 1 0 0 0-1.414 1.415l3.526 3.526.01.01a1 1 0 0 0 1.414 0l7.778-7.779a1 1 0 0 0 0-1.414Z"
  })));
};
export default SvgCheckIcon;